export const getApiErrorMessage = (
  error: unknown,
  fallback = "Something went wrong"
): string => {
  if (error && typeof error === "object" && !("response" in error)) {
    const body = error as { data?: string; message?: string };
    if (typeof body.data === "string" && body.data.trim()) {
      return body.data;
    }
    if (typeof body.message === "string" && body.message.trim()) {
      return body.message;
    }
  }

  const err = error as {
    response?: {
      data?:
        | string
        | {
            data?: string;
            message?: string;
          };
    };
    message?: string;
  };

  const responseData = err?.response?.data;

  if (typeof responseData === "string" && responseData.trim()) {
    return responseData;
  }

  if (responseData && typeof responseData === "object") {
    if (typeof responseData.data === "string" && responseData.data.trim()) {
      return responseData.data;
    }
    if (typeof responseData.message === "string" && responseData.message.trim()) {
      return responseData.message;
    }
  }

  return fallback;
};
